export const USER_ACTIVITY_LOGS_TABLE_COLUMNS = ['activityLog', 'timeStamp', 'user', 'actions'];

export const ACTIVITY_LOGS_TABLE_COLUMNS = ['field', 'oldValue', 'newValue', 'otherDetails'];

export const USER_ACTIVITY_LOG_PAGESIZE_OPTIONS = [5, 10, 20, 30, 50];

export const UserLogListMapping = {
  basicConfiguration: {
    key: 'FleetSdkBasicConfigurationsChange',
    label: 'Configurations Changed',
  },
  customConfiguration: {
    key: 'FleetSdkCustomEventConfigurationsChange',
    label: 'Custom Configurations Changed',
  },
  advanceConfiguration: {
    key: 'FleetSdkAdvancedConfigurationsChange',
    label: 'Advanced Configurations Changed',
  },
  configurationDefault: {
    key: 'FleetSdkBasicConfigurationsDefault',
    label: 'Configurations Reset',
  },
  driverConsentAudio: {
    key: 'FleetDriverConsentForAudioChange',
    label: 'Driver Consent For Audio Changed',
  },
  coachingConfigurations: {
    key: 'FleetCoachingConfigurationsChange',
    label: 'Coaching Configurations Changed',
  },
  attributeAdded: {
    key: 'FleetAttributeAdded',
    label: 'Attribute Added',
  },
  attribute: {
    key: 'FleetAttributeChanged',
    label: 'Attribute Changed',
  },
  attributeDeleted: {
    key: 'FleetAttributeDeleted',
    label: 'Attribute Deleted',
  },
  tagsAdded: {
    key: 'FleetTagsAdded',
    label: 'Tags Added',
  },
  tag: {
    key: 'FleetTagChanged',
    label: 'Tag Changed',
  },
  tagDeleted: {
    key: 'FleetTagDeleted',
    label: 'Tag Deleted',
  },
  entity: {
    key: 'FleetEntityChanged',
    label: 'Entity Changed',
  },
  customEventConfiguration: {
    key: 'CustomEventSettingsChange',
    label: 'Custom Event Settings Changed',
  },
  standardEventConfiguration: {
    key: 'GlobalStandardEventSettingsChange',
    label: 'Standard Event Configurations Changed',
  },
  standardEventLevelSettings: {
    key: 'StandardEventLevelSettingsChange',
    label: 'Standard Event Level Changed',
  },
};
